"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A simple flag that returns `true` or `false` based on if the program is running in node environment or not.
 */
exports.inNode = Boolean(typeof process !== 'undefined' && process.versions && process.versions.node);
